import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const MpSourceRedirecter = () => {
    const location = useLocation();
    useEffect(() => {
        const href = window.location.href;
        const search = window.location.search;

        if (search.includes('?code=')) {
            let newUrl = href;
            if (!href.includes('/#/')) {
                newUrl = href.replace('/merchants', '/#/merchants');
            }
            const merchantSelect = localStorage.getItem('merchant-cadena');
            if (merchantSelect) {
                const merchantId = merchantSelect.split('-.-')[0];
                if (merchantId) {
                    const urlCode = href.split('?')[1];
                    newUrl = `${window.location.origin}/#/merchants/${merchantId}/show/?${urlCode}`;
                    let url = newUrl.split('#/');
                    newUrl = `${url[0]}#/${url[1]}`;
                }
            }
            window.location.replace(newUrl);
        }
    }, [location.pathname, location.search, location.hash]);
    return null;
};

export default MpSourceRedirecter;